import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import React, { useContext, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import StaticCriteriaArguments from '../filter-options/static-criteria-arguments';
import FilterBar from '../../../components/filter-bar';
import { InventoryContext } from './inventory-context';
import { inventoryFilters } from '../filter-options';
import { criteriaOperatorsMap } from '../../../containers/base-filter-bar-container/criteria-operators';
import { getCriteriaArguments } from '../../../containers/customers-filter-bar-container/criteria-arguments';
import { useInventoryTrackingEnabled } from '../../../hooks/use-seller-setting';

import style from './filter-bar-style.module.less';
import { FormattedMessage } from 'react-intl';
import FilterCheckbox from '../products/checkbox';
import messages from '../messages';

const showInactiveCheckboxLabel = <FormattedMessage {...messages.filterBarShowInactive} />;
const AlertIcon = <FontAwesomeIcon className={style.icon} icon={faExclamationTriangle} />;
const InventoryTrackingMessage = (
  <b>
    <FormattedMessage
      {...messages.inventoryTrackingDisabledWarning}
      values={{
        a: (chunks) => <Link to='/settings/inventorysettings'>{chunks}</Link>,
      }}
    />
  </b>
);

const InventoryFilterBar = () => {
  const { appliedFilters, clearFilters, onFiltersChanged } = useContext(InventoryContext);
  const baseCriteriaArguments = useSelector(getCriteriaArguments);
  const criteriaArgumentsMap = useMemo(
    () => ({
      ...baseCriteriaArguments,
      ...StaticCriteriaArguments,
    }),
    [baseCriteriaArguments],
  );

  const showInactive = useMemo(() => appliedFilters.find(({ filterById }) => filterById === 'showInactive'), [appliedFilters]);
  const inventoryTrackingEnabled = useInventoryTrackingEnabled();

  const toggleShowInactive = useCallback(() => {
    const newFilters = appliedFilters.filter(({ filterById }) => filterById !== 'showInactive');
    if (!showInactive) {
      newFilters.push({
        criterionArgumentValue: true,
        filterById: 'showInactive',
        filterValue: 'ShowInactive',
        id: 'showInactive',
        type: 'TYPE_BOOLEAN',
      });
    }
    onFiltersChanged(newFilters);
  }, [appliedFilters, onFiltersChanged, showInactive]);

  return (
    <>
      <div className={style['filter-bar-wrapper']}>
        <FilterBar
          allFilterBys={inventoryFilters}
          appliedFilters={appliedFilters}
          clearFilters={clearFilters}
          criteriaArgumentsMap={criteriaArgumentsMap}
          criteriaOperatorsMap={criteriaOperatorsMap}
          onFiltersChanged={onFiltersChanged}
          popularFilterBys={inventoryFilters}
        />
      </div>
      <div className={style['filter-bar-actions-wrapper']}>
        <div className={style['sidebar-toggle']}>
          <FilterCheckbox isChecked={showInactive} label={showInactiveCheckboxLabel} onChecked={toggleShowInactive} />
        </div>
        {!inventoryTrackingEnabled && (
          <div className={style['alert-danger']}>
            {AlertIcon}
            {InventoryTrackingMessage}
          </div>
        )}
      </div>
    </>
  );
};

export default InventoryFilterBar;
